<template>
  <el-form ref="form" :model="formData">
    <el-form-item :label="$t('lang.选择工具')+ '：'">
      <el-checkbox-group v-model="formData.accessoryList" :disabled="disabled">
        <div class="check-group">
          <el-checkbox :label="i.accessoryCode" v-for="i in accessoryList" :key="i.accessoryCode">
            <div class="check-item">
              <div class="check-content">
                <div>
                  <i class="el-icon-success check-icon" v-if="formData.accessoryList.includes(i.accessoryCode)"></i>
                  <i class="el-icon-circle-check check-icon-size" v-else></i>
                </div>
                <div class="content">
                  <img class="check-img" :src="i.photo | filterImg(that)">
                </div>
              </div>

              <div class="check-name">{{ i.name }}</div>
            </div>
          </el-checkbox>
        </div>
      </el-checkbox-group>
    </el-form-item>

    <div class="btn-box">
      <el-button @click="$router.back()" v-if="disabled">{{ $t('lang.返回') }}</el-button>
      <template v-else>
        <el-button @click="$emit('save')">{{ $t('lang.保存') }}</el-button>
        <el-button v-if="$store.getters.hasTranslate" @click="$emit('translate')">{{$t('lang.翻译')}}</el-button>
      </template>
      <el-button type="primary" @click="$emit('lastStep')">{{ $t('lang.上一步') }}</el-button>
      <el-button type="primary" @click="$emit('next')">{{ $t('lang.下一步') }}</el-button>
    </div>

  </el-form>
</template>

<script>
import {loadAccessory} from "../../js/common";

export default {
  name: "ToolForm",
  props: {
    status: {
      type: String,
      default: 'add'
    }
  },
  data() {
    return {
      accessoryList: [],
      that: this,
      formData: {
        accessoryList: []
      },
      disabled: false,
    }
  },

  watch: {
    status: {
      handler(state) {
        if(state == 'detail') {
          this.disabled = true;
        }
      },
      immediate: true,
      deep: true,
    },
    lang: {
      async handler() {
        // 根据品牌商加载不同的 配件工具
        // this.handleLoadToolByBrand();
        this.accessoryList = await loadAccessory(this, this.lang);

        // if(!this.isBrand) {
        //   this.accessoryList = await loadAccessory(this, this.lang);
        // } else {
        //   this.handleLoadToolByBrand();
        // }
      },
      immediate: true,
      deep: true,
    },
    "formData.accessoryList": {
      handler(list) {
        this.$store.commit("CHANGE_RECIPE", {accessoryList: list})
      },
      immediate: false,
      deep: true,
    }
  },
  methods: {
    handleGetData() {
      let {accessoryList} = this.$store.state.recipe;
      if(accessoryList && accessoryList.length) {
        this.formData.accessoryList = accessoryList;
      }
    },

    // 获取 058品牌商 配置的配件
    handleLoadToolByBrand() {
      this.$http.get(this.$api.accessory.list, {params: {onPage: false, lang: this.lang}}).then(async (resp) => {
        this.accessoryList = resp.data.data.accessorys;

        // const brandList = resp.data.data.accessorys;
        // const allList = await loadAccessory(this, this.lang);
        // let list = [...brandList, ...allList];
        // const codes = [...new Set(list.map(item => item.accessoryCode))];
        // this.accessoryList = codes.map(item => {
        //   return list.find(accessory => accessory.accessoryCode === item)
        // });
      })
    }

  },
  computed: {
    lang() {
      return this.$store.state.recipe.lang;
    },
    // 判断当前是否 是058 品牌商
    isBrand() {
      const number = this.$store.state.userInfo.brandOwnerNumber
      return number === "058";
    }
  },
  async created() {
    // if(this.isBrand) this.handleLoadToolByBrand();
    // this.accessoryList = await loadAccessory(this, this.lang)
  },
  activated() {
    this.$nextTick(() => {
      this.handleGetData();
    })
  }
}
</script>

<style scoped>

.check-group {
  width: 900px;
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  //flex-wrap: wrap;
  margin: 24px 0;
}

.check-item {
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-right: 24px;
  margin-bottom: 12px;

}

.check-content {
  width: 140px;
  height: 140px;
  border: 1px solid #dddddd;
  border-radius: 6px;
  display: flex;
  flex-direction: column;
  padding: 8px;
  box-sizing: border-box;
  margin-bottom: 12px;
}

.check-icon-size {
  font-size: 26px;
  color: #000000;
  opacity: .3;
}

.check-icon {
  font-size: 26px;
  color: #2f86dd;
}


.content {
  display: flex;
  justify-content: center;
  align-items: center;
}

.check-img {
  width: 60px;
  height: 60px;
}

/deep/ .el-checkbox__inner {
  display: none !important;
}

.check-name {
  width: 140px;
  text-align: center;
  white-space: normal;
}

</style>
